<template>
    <div class="p-grid p-jc-center p-pt-4">
        <div class="p-col-12 p-md-9 p-mx-auto p-p-4">
            <div class="p-grid">
                <div class="p-col-12 p-md-6">
                    <Dropdown class="p-text-left" style="width: 100% !important" placeholder="Select Organization"
                        v-model="currentSSUniqueTournamentId" :options="organizationList"
                        @change="organizationSelected($event)"
                        optionLabel="name" optionValue="ss_unique_tournament_id"
                        :loading="isOrganizationListLoading" />
                </div>
                <div class="p-col-12 p-md-6 p-text-right">
                    <Button label="Update Teams"
                        class="p-button-sm p-button-text p-button-outlined p-button-info p-text-right"
                        :loading="isOrganizationTeamsUpdating"
                        @click="updateTeams(currentSSUniqueTournamentId)"
                        v-show="currentSSUniqueTournamentId !== undefined && currentSSUniqueTournamentId !== null" />
                </div>
            </div>
        </div>
    </div>

    <!-- team list datatable -->
    <ProgressBar mode="indeterminate" v-show="isTeamListLoading || isOrganizationTeamsUpdating" style="height: .2em" />

    <div class="p-grid">
        <div class="p-col-12 p-md-10 p-mx-auto p-mt-2">
            <DataTable v-show="!isTeamListLoading && !isOrganizationTeamsUpdating && teamList !== null && teamList.length > 0" :paginator="false" :rowHover="true"
                :value="teamList" editMode="row" dataKey="id" v-model:filters="filters" filterDisplay="menu"
                v-model:editingRows="editingRows" @row-edit-save="onRowEditSave" responsiveLayout="scroll"
                :globalFilterFields="['name', 'name_code']" >
                <Column field="ss_team_id" header="SS Team Id" sortable style="width:10%"></Column>
                <Column field="slug" header="Slug" sortable style="width:10%"></Column>
                <Column field="original_name" header="Original Name" sortable style="width:10%"></Column>
                <Column field="original_name_code" header="Original Name Code" style="width:10%"></Column>
                <Column field="name" header="Name" sortable style="width:15%">
                    <template #body="{data, field}">
                        {{data[field]}}
                    </template>
                    <template #editor="{data, field}">
                        <InputText v-model="data[field]" placeholder="Name" class="p-col-12" id="name" type="text" />
                    </template>
                </Column>
                <Column field="name_code" header="Name Code" style="width:10%">
                    <template #body="{data, field}">
                        {{data[field]}}
                    </template>
                    <template #editor="{data, field}">
                        <InputText v-model="data[field]" maxlength="3" placeholder="Name Code" class="p-col-12" id="name_code" type="text" />
                    </template>
                </Column>
                <Column field="team_colors" header="Team Colors" style="width:25%">
                    <template #body="{data, field}">
                        <div class="p-grid">
                            <div class="p-col-12 p-md-3 p-text-light p-text-center">
                                Primary <br/>
                                <ColorPicker v-model="data[field].primary" :disabled="true" class="p-mt-1" />
                            </div>
                            <div class="p-col-12 p-md-3 p-text-light p-text-center">
                                Secondary <br/>
                                <ColorPicker v-model="data[field].secondary" :disabled="true" class="p-mt-1" />
                            </div>
                            <div class="p-col-12 p-md-3 p-text-light p-text-center">
                                Text <br/>
                                <ColorPicker v-model="data[field].text" :disabled="true" class="p-mt-1" />
                            </div>
                            <div class="p-col-12 p-md-3 p-text-light p-text-center">
                                Dominant <br/>
                                <ColorPicker v-model="data[field].dominant" :disabled="true" class="p-mt-1" />
                            </div>
                        </div>
                    </template>
                    <template #editor="{data, field}">
                        <div class="p-grid">
                            <div class="p-col-12 p-md-3 p-text-light p-text-center">
                                Primary <br/>
                                <ColorPicker v-model="data[field].primary" class="p-mt-1" />
                            </div>
                            <div class="p-col-12 p-md-3 p-text-light p-text-center">
                                Secondary <br/>
                                <ColorPicker v-model="data[field].secondary" class="p-mt-1" />
                            </div>
                            <div class="p-col-12 p-md-3 p-text-light p-text-center">
                                Text <br/>
                                <ColorPicker v-model="data[field].text" class="p-mt-1" />
                            </div>
                            <div class="p-col-12 p-md-3 p-text-light p-text-center">
                                Dominant <br/>
                                <ColorPicker v-model="data[field].dominant" class="p-mt-1" />
                            </div>
                        </div>
                    </template>
                </Column>
                <Column :rowEditor="currentSSUniqueTournamentId === 52" header="Edit" style="width:5%" v-show="currentSSUniqueTournamentId === 52"></Column>
                <Column header="Delete" style="width:5%" v-show="currentSSUniqueTournamentId === 52">
                    <template #editor="{data, index}">
                        <Button label="" icon="pi pi-trash" class="p-button-rounded p-button-text p-button-plain"
                            @click="deleteTeam(data.ss_unique_tournament_id, data.id, index)" />
                        <Button label="" icon="pi pi-shield" class="p-button-rounded p-button-text p-button-plain"
                            @click="showTeamOrganizationsDialog(data.name, data.ss_team_id)" />
                    </template>
                </Column>
            </DataTable>
        </div>
    </div>

    <!-- teams_organizations iliskilendirmesi icin dialog modal eklenecek -->
    <Dialog v-model:visible="showDialog" :header="'Team Organizations | ' + newTeamOrganizationPayload.team_name" :modal="true" class="p-fluid p-col-8">
        <div class="p-grid p-jc-end">
            <div class="p-col-3 p-md-3">
                <Button label="Add team organization" class=" p-button-text p-button-sm p-button-info"
                    @click="newTeamOrganizationPayload.visible = !newTeamOrganizationPayload.visible" />
            </div>
        </div>
        <div v-show="newTeamOrganizationPayload.visible" class="p-grid">
            <div class="p-col-6 p-md-4">
                <Dropdown class="p-text-left" style="width: 100% !important" placeholder="Select Organization"
                    v-model="newTeamOrganizationPayload.ss_unique_tournament_id" :options="organizationList"
                    optionLabel="name" optionValue="ss_unique_tournament_id"
                    :loading="isOrganizationListLoading" />
            </div>
            <div class="p-col-6 p-md-3">
                <Button label="Insert Team Organization" class="p-button-text p-button-sm p-button-primary"
                    @click="insertTeamOrganization()"
                    :loading="newTeamOrganizationPayload.loading" />
            </div>
        </div>

        <div class="p-field p-text-center p-mt-2">
            <DataTable v-show="!isTeamOrganizationsListLoading && teamOrganizationsList !== null && teamOrganizationsList.length > 0"
                :loading="isTeamOrganizationsListLoading" :paginator="false" :rowHover="true"
                :value="teamOrganizationsList" dataKey="id" filterDisplay="menu" responsiveLayout="scroll" >
                <Column field="ss_unique_tournament_id" header="SS Unique Tournament ID" sortable style="width:25%" />
                <Column field="name" header="Name" sortable style="width:35%" />
                <Column field="active" header="Active" style="width:10%" />
                <Column field="log_date" header="Log Date" style="width:20%">
                    <template #body="{data}">
                        <div v-html="getFormattedDate(data.log_date)" style="width:100%"></div>
                    </template>
                </Column>
                <Column header="" style="width:10%">
                    <template #body="{data}">
                        <Button label="" icon="pi pi-trash" class="p-button-rounded p-button-text p-button-plain"
                            @click="deleteTeamOrganization(data.ss_team_id, data.id)" />
                    </template>
                </Column>
            </DataTable>

            <p v-show="!isTeamOrganizationsListLoading && (teamOrganizationsList === null || teamOrganizationsList.length === 0)">
                No organization found for this team.
            </p>
        </div>
    </Dialog>

    <Divider align="center" class="p-mt-6">
        <div class="p-d-inline-flex p-ai-center">
        <b>About</b>
        </div>
    </Divider>

    <div class="p-col-12 p-md-9 p-mx-auto p-mt-2 p-text-left">
        <div class="p-d-flex">
            <i class="fa fa-info p-mr-3"></i> Sistemde kayıtlı takım bilgileri yönetilir. (teams tablosu)
            <br/> Özellikle uygulamayı yükleyen kullanıcıların seçecekleri favori takım bu listeden getirilir. (Süper Lig takımlarından seçim yapılır)
            <br/> Seçilen bir turnuva için takımların güncellenmesi yapılabilir. (Update Teams)
            <br/> Yalnızca Süper Lig takımları için düzenleme ve silme yapılabilir.
            <br/> Süper Lig takımları için;
            <br/> - Name, Name Code (kısaltma, max. 3 karakter) ve Team Colors (primary, secondary, text) alanları güncellenebilir.
            <br/> - Takımların aktif olarak yer aldıkları diğer turnuva bilgileri de eklenebilir/çıkarılabilir. (Türkiye Kupası, UEFA Şampiyonlar Ligi, UEFA Avrupa Ligi, UEFA Konferans Ligi gibi)
            <br/> &nbsp; Takımların Süper Lig haricindeki maçlarını tespit ederek MyTeam ekranında Sıradaki Maç alanında ve Performans grafiğinde sonucunu gösterebilmek için gerekli.
        </div>
    </div>
</template>

<script>
import { FilterMatchMode } from 'primevue/api'
import Dropdown from 'primevue/dropdown'
import Button from 'primevue/button'
import ProgressBar from 'primevue/progressbar'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import ColorPicker from 'primevue/colorpicker'
import Dialog from 'primevue/dialog'
import Divider from 'primevue/divider'

import Const from '../utils/const'
import { isEmpty } from '../utils/utils'
import moment from 'moment'

export default {
    name: 'TeamManagement',
    emits: ["loginResult", "pageLoaded"],
    components: {
        Dropdown, Button, ProgressBar, DataTable, Column, ColorPicker, Dialog, Divider
    },
    data() {
        return {
            currentSSUniqueTournamentId: null,
            isOrganizationListLoading: false,
            organizationList: [],
            isOrganizationTeamsUpdating: false,
            teamList: [],
            isTeamListLoading: false,
            editingRows: [],
            filters: {
                'name': {value: null, matchMode: FilterMatchMode.CONTAINS},
                'name_code': {value: null, matchMode: FilterMatchMode.CONTAINS}
            },
            showDialog: false,
            isTeamOrganizationsListLoading: false,
            teamOrganizationsList: [],
            newTeamOrganizationPayload: {}
        }
    },
    beforeMount() {
        var page = {
            title: "Team Management"
        }
        this.$emit('pageLoaded', page)
    },
    mounted() {
        this.loadOrganizations()
    },
    methods: {
        loadOrganizations() {
            let self = this,
                toast = self.$toast,
                cookies = self.$cookies,
                token = cookies.get('token');
            
            self.isOrganizationListLoading = true
            self.$http.get('api/config/organization/all-set?service=ss', {
                headers: {
                    'authorization': 'Bearer ' + token
                }
            }).then(function (response) {
                self.isOrganizationListLoading = false
                if(!isEmpty(response.data.kod) && response.data.kod === Const.KOD.basarili && !isEmpty(response.headers['refresh-token'])) {
                    cookies.set('token', response.headers['refresh-token']);
                    self.organizationList = response.data.items
                } else if(response.data.kod === Const.KOD.oturumSonlandi) {
                    self.$router.push('/login')
                } else {
                    toast.add({severity:'warn', summary: 'Loading organizations failed', detail:response.data.mesaj, life: 3000});
                }
            }).catch(function (err) {
                self.isOrganizationListLoading = false
                toast.add({severity:'error', summary: 'Error', detail:err});
                console.log(err)
            });
        },
        updateTeams(ssTournamentId) {
            let self = this
            
            self.$confirm.require({
                message: 'Are you sure you want to update teams for this organization?\nAll team names, name codes and colors will be overriden.',
                header: 'Update Teams',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: 'Update teams',
                rejectLabel: 'Cancel',
                accept: () => {
                    let toast = self.$toast,
                        cookies = self.$cookies,
                        token = cookies.get('token');
                    
                    self.isOrganizationTeamsUpdating = true
                    self.$http.post('api/tournaments/source/ss/'+ssTournamentId+'/update-teams', null, {
                        headers: {
                            'authorization': 'Bearer ' + token
                        }
                    }).then(function (response) {
                        self.isOrganizationTeamsUpdating = false
                        if(!isEmpty(response.data.kod) && response.data.kod === Const.KOD.basarili && !isEmpty(response.headers['refresh-token'])) {
                            cookies.set('token', response.headers['refresh-token']);

                            // update team list
                            self.organizationSelected({ value: ssTournamentId })
                        } else if(response.data.kod === Const.KOD.oturumSonlandi) {
                            self.$router.push('/login')
                        } else {
                            toast.add({severity:'warn', summary: 'Loading organizations failed', detail:response.data.mesaj, life: 3000});
                        }
                    }).catch(function (err) {
                        self.isOrganizationTeamsUpdating = false
                        toast.add({severity:'error', summary: 'Error', detail:err});
                        console.log(err)
                    });
                },
                reject: () => {}
            })
        },
        organizationSelected(event) {
            let self = this,
                toast = self.$toast,
                cookies = self.$cookies,
                token = cookies.get('token'),
                ssUniqueTournamentId = event.value;
            
            self.isTeamListLoading = true
            self.$http.get('api/tournaments/'+ssUniqueTournamentId+'/teams', {
                headers: {
                    'authorization': 'Bearer ' + token
                }
            }).then(function (response) {
                self.isTeamListLoading = false
                if(!isEmpty(response.data.kod) && response.data.kod === Const.KOD.basarili && !isEmpty(response.headers['refresh-token'])) {
                    cookies.set('token', response.headers['refresh-token']);
                    self.teamList = response.data.items
                } else if(response.data.kod === Const.KOD.oturumSonlandi) {
                    self.$router.push('/login')
                } else {
                    toast.add({severity:'warn', summary: 'Loading organizations failed', detail:response.data.mesaj, life: 3000});
                }
            }).catch(function (err) {
                self.isTeamListLoading = false
                toast.add({severity:'error', summary: 'Error', detail:err});
                console.log(err)
            });
        },
        onRowEditSave(event) {
            let { newData, index } = event;

            let self = this,
                teamId = newData.id,
                toast = self.$toast,
                toastMessage = null,
                cookies = self.$cookies,
                token = cookies.get('token');

            if(isEmpty(newData.name)) {
                toastMessage = 'Team name is empty!'
            } else if(isEmpty(newData.name_code)) {
                toastMessage = 'Name code is empty!'
            }

            if(!isEmpty(toastMessage)) {
                toast.add({severity:'warn', summary: 'Something missing!', detail: toastMessage, life: 3000});
                return
            }

            let payload = {
                name: newData.name,
                name_code: newData.name_code,
                team_colors: newData.team_colors
            }

            self.$http.patch('api/tournaments/'+self.currentSSUniqueTournamentId+'/teams/'+teamId, payload, {
                headers: {
                    'authorization': 'Bearer ' + token
                }
            }).then(function (response) {
                if(!isEmpty(response.data.kod) && response.data.kod === Const.KOD.basarili && !isEmpty(response.headers['refresh-token'])) {
                    cookies.set('token', response.headers['refresh-token']);
                    
                    self.teamList[index] = response.data.item;

                    toast.add({severity:'success', summary: 'Success', detail: 'Updated successfully.', life: 3000});
                } else {
                    toast.add({severity:'warn', summary: 'Update failed', detail:response.data.mesaj, life: 3000});
                }
            }).catch(function (err) {
                console.log(err)
                toast.add({severity: 'error', summary: 'Error', detail: err});
            });
        },
        deleteTeam(tournamentId, teamId, index) {
            let self = this,
                toast = self.$toast,
                cookies = self.$cookies,
                token = self.$cookies.get('token');
            
            self.$confirm.require({
                message: 'Are you sure you want to delete this team?\nTeam organizations will also be deleted.',
                header: 'Delete',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: 'Delete',
                rejectLabel: 'Cancel',
                accept: () => {
                    self.$http.delete('api/tournaments/'+tournamentId+'/teams/'+teamId, {
                        headers: {
                            'authorization': 'Bearer ' + token
                        }
                    })
                    .then(function (response) {
                        if(!isEmpty(response.data.kod) && response.data.kod === Const.KOD.basarili && !isEmpty(response.headers['refresh-token'])) {
                            cookies.set("token", response.headers['refresh-token']);

                            self.teamList.splice(index, 1)

                            toast.add({severity:'success', summary: 'Success', detail: 'Team deleted successfully.', life: 3000});
                        } else {
                            toast.add({severity:'warn', summary: 'Deleting team failed', detail:response.data.mesaj, life: 3000});
                        }
                    })
                    .catch(function (err) {
                        console.log(err)
                        toast.add({severity: 'error', summary: 'Error', detail: err});
                    });
                },
                reject: () => {
                }
            });
        },
        showTeamOrganizationsDialog(teamName, teamId) {
            let self = this,
                toast = self.$toast,
                cookies = self.$cookies,
                token = cookies.get('token');
            
            self.newTeamOrganizationPayload.team_name = teamName
            self.newTeamOrganizationPayload.ss_team_id = teamId
            
            self.showDialog = true
            self.isTeamOrganizationsListLoading = true
            self.$http.get('api/teams/'+teamId+'/organizations', {
                headers: {
                    'authorization': 'Bearer ' + token
                }
            }).then(function (response) {
                self.isTeamOrganizationsListLoading = false
                if(!isEmpty(response.data.kod) && response.data.kod === Const.KOD.basarili && !isEmpty(response.headers['refresh-token'])) {
                    cookies.set('token', response.headers['refresh-token']);
                    self.teamOrganizationsList = response.data.items
                } else if(response.data.kod === Const.KOD.oturumSonlandi) {
                    self.$router.push('/login')
                } else {
                    toast.add({severity:'warn', summary: 'Loading team organizations failed', detail:response.data.mesaj, life: 3000});
                }
            }).catch(function (err) {
                self.isTeamOrganizationsListLoading = false
                toast.add({severity:'error', summary: 'Error', detail:err});
                console.log(err)
            });
        },
        deleteTeamOrganization(teamId, teamOrganizationId) {
            let self = this,
                toast = self.$toast,
                cookies = self.$cookies,
                token = self.$cookies.get('token');
            
            self.$confirm.require({
                message: 'Are you sure you want to delete this team organization relation?',
                header: 'Delete',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: 'Delete',
                rejectLabel: 'Cancel',
                accept: () => {
                    self.$http.delete('api/teams/'+teamId+'/organizations/'+teamOrganizationId, {
                        headers: {
                            'authorization': 'Bearer ' + token
                        }
                    })
                    .then(function (response) {
                        if(!isEmpty(response.data.kod) && response.data.kod === Const.KOD.basarili && !isEmpty(response.headers['refresh-token'])) {
                            cookies.set("token", response.headers['refresh-token']);

                            let teamName = self.newTeamOrganizationPayload.team_name
                            self.showTeamOrganizationsDialog(teamName, teamId)

                            toast.add({severity:'success', summary: 'Success', detail: 'Team organization relation deleted successfully.', life: 3000});
                        } else {
                            toast.add({severity:'warn', summary: 'Deleting team organization relation failed', detail: response.data.mesaj, life: 3000});
                        }
                    })
                    .catch(function (err) {
                        console.log(err)
                        toast.add({severity: 'error', summary: 'Error', detail: err});
                    });
                },
                reject: () => {
                }
            });
        },
        insertTeamOrganization() {
            let self = this,
                toast = self.$toast,
                cookies = self.$cookies,
                toastMessage = null,
                token = cookies.get('token');
            
            let teamId = self.newTeamOrganizationPayload.ss_team_id
            let tournamentId = self.newTeamOrganizationPayload.ss_unique_tournament_id;

            if(isEmpty(tournamentId)) {
                toastMessage = 'Tournament is not selected!'
            } else if(isEmpty(teamId)) {
                toastMessage = 'Team is not selected!'
            }

            if(!isEmpty(toastMessage)) {
                toast.add({severity:'warn', summary: 'Something missing!', detail: toastMessage, life: 3000});
                return
            }

            let payload = {
                ss_unique_tournament_id: tournamentId
            }

            self.newTeamOrganizationPayload.loading = true
            self.$http.post('api/teams/'+teamId+'/organizations', payload, {
                headers: {
                    'authorization': 'Bearer ' + token
                }
            }).then(function (response) {
                self.newTeamOrganizationPayload.loading = false
                if(!isEmpty(response.data.kod) && response.data.kod == Const.KOD.basarili && !isEmpty(response.headers['refresh-token'])) {
                    cookies.set("token", response.headers['refresh-token']);

                    let teamName = self.newTeamOrganizationPayload.team_name
                    self.showTeamOrganizationsDialog(teamName, teamId)

                    toast.add({severity:'success', summary: 'Success', detail: 'Team organization added successfully.', life: 3000});
                } else {
                    toast.add({severity:'warn', summary: 'Update team organization failed', detail:response.data.mesaj, life: 3000});
                }
            }).catch(function (err) {
                self.newTeamOrganizationPayload.loading = false
                console.log(err)
                toast.add({severity: 'error', summary: 'Error', detail: err});
            });
        },
        getFormattedDate(logDate) {
            return moment(new Date(logDate)).format('DD/MM/YYYY HH:mm');
        },
        getFormattedComment(comment) {
            return !isEmpty(comment) ? comment.replaceAll('\n', '<br/>') : null
        }
    }
}
</script>
